"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _Fab = _interopRequireDefault(require("@material-ui/core/Fab"));

var _reactRedux = require("react-redux");

var _emailDialog = _interopRequireDefault(require("./emailDialog"));

var _shareDialog = _interopRequireDefault(require("./shareDialog"));

var _actions = require("../../../../redux/locations/actions");

var _selectors = require("../../../../redux/locations/selectors");

var _icEmail = _interopRequireDefault(require("../../../../img/ic-email.png"));

var _icFax = _interopRequireDefault(require("../../../../img/ic-fax.png"));

var _icPhone = _interopRequireDefault(require("../../../../img/ic-phone.png"));

var _icWebsite = _interopRequireDefault(require("../../../../img/ic-website.png"));

var _icFacebook = _interopRequireDefault(require("../../../../img/ic-facebook.png"));

var _icTwitter = _interopRequireDefault(require("../../../../img/ic-twitter.png"));

var _icShare = _interopRequireDefault(require("../../../../img/ic-share.png"));

var _icPrint = _interopRequireDefault(require("../../../../img/ic-print.png"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ContactPanel = function ContactPanel(_ref) {
  var location = _ref.location;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showContactForm = _useState2[0],
      setShowContactForm = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showShareForm = _useState4[0],
      setShowShareForm = _useState4[1];

  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSearchSelector = (0, _selectors.useSearchSelector)(),
      lastPageViewId = _useSearchSelector.lastPageViewId;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "contact-info-container flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex contact-info-link-container flex2"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }, location && location.url && /*#__PURE__*/_react.default.createElement("a", {
    href: location.url,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: function onClick() {
      return dispatch((0, _actions.trackLocationClick)(location.id, "website_clicks", lastPageViewId));
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-contact-container-item flex bodyFont"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "contact-info-item-icon",
    src: _icWebsite.default,
    alt: "url"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginLeft10 flex align-items-center"
  }, location.url.replace(/https?:\/\//, "")))), location && location.phoneNumber && /*#__PURE__*/_react.default.createElement("a", {
    href: "tel://".concat(location.phoneNumber),
    onClick: function onClick() {
      return dispatch((0, _actions.trackLocationClick)(location.id, "phone_clicks", lastPageViewId));
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-contact-container-item flex bodyFont"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "contact-info-item-icon",
    src: _icPhone.default,
    alt: "phone"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginLeft10 flex align-items-center"
  }, location.phoneNumber))), location && location.faxNumber && /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-contact-container-item flex bodyFont"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "contact-info-item-icon",
    src: _icFax.default,
    alt: "fax"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginLeft10 flex align-items-center"
  }, location.faxNumber))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1 flex"
  }, location && (location.facebookPageId || location.twitterHandle) && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }, location && location.facebookPageId && /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.facebook.com/".concat(location.facebookPageId)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-contact-container-item flex bodyFont"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "contact-info-item-icon",
    src: _icFacebook.default,
    alt: "facebook"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginLeft10 flex align-items-center"
  }, "Facebook"))), location && location.twitterHandle && /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.twitter.com/".concat(location.twitterHandle)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-contact-container-item flex bodyFont"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "contact-info-item-icon",
    src: _icTwitter.default,
    alt: "twitter"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginLeft10 flex align-items-center"
  }, "Twitter")))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex1 align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex1 contact-info-fab-container"
  }, /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "marginRight20 contact-info-fab"
  }, /*#__PURE__*/_react.default.createElement(_Fab.default, {
    size: "medium",
    color: "secondary",
    onClick: function onClick() {
      return window.print();
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "contact-info-action-icon",
    src: _icPrint.default,
    alt: "print"
  })))), location && location.emailAddress && /*#__PURE__*/_react.default.createElement("div", {
    className: "marginRight20 contact-info-fab"
  }, /*#__PURE__*/_react.default.createElement(_Fab.default, {
    size: "medium",
    color: "secondary",
    onClick: function onClick() {
      return setShowContactForm(true);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "contact-info-action-icon",
    src: _icEmail.default,
    alt: "contact"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "contact-info-fab"
  }, /*#__PURE__*/_react.default.createElement(_Fab.default, {
    size: "medium",
    color: "secondary",
    onClick: function onClick() {
      return setShowShareForm(true);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "contact-info-action-icon",
    src: _icShare.default,
    alt: "share"
  }))))), /*#__PURE__*/_react.default.createElement(_emailDialog.default, {
    location: location,
    open: showContactForm,
    onClose: function onClose() {
      return setShowContactForm(false);
    }
  }), /*#__PURE__*/_react.default.createElement(_shareDialog.default, {
    location: location,
    open: showShareForm,
    onClose: function onClose() {
      return setShowShareForm(false);
    }
  }));
};

var _default = ContactPanel;
exports.default = _default;